import { AppDefinition } from '../../types/apps';

export const AppBuilderAppDefinition: AppDefinition = {
  appId: 'app-builder',
  name: 'App Builder',
  description: 'AI-powered app development IDE',
  version: '1.0.0',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Code',
    phosphorWeight: 'duotone',
    color: '#6366f1',
  },
  component: 'AppBuilderApp',
  entityTypes: ['AppProject', 'WebsiteProject'],
  entityIcons: {
    'AppProject': {
      type: 'phosphor',
      phosphorIcon: 'Code',
      phosphorWeight: 'duotone'
    },
    'WebsiteProject': {
      type: 'phosphor',
      phosphorIcon: 'Globe',
      phosphorWeight: 'duotone'
    }
  },
  fileTypeIcons: {},
  requiresProps: true,
  requiresEntity: true,
  experimental: true,
};

export default AppBuilderAppDefinition;
